const notifications = {
	alert: {
		text: '重要',
		color: 'error',
		topColor: 'error',
	},
	info: {
		text: 'お知らせ',
		color: 'userinfo',
		topColor: 'primary',
	},
	notice: {
		text: 'システム',
		color: 'primary',
		topColor: 'primary',
	},
	default: {
		text: '',
		color: '',
	},
	getCategory(category) {
		let type = this.hasOwnProperty(category) ? category : 'default';
		return this[type];
	},
};
export default ({ app }, inject) => {
	inject('notificationCategory', notifications);
};
